import SlatesBaseModel from "./SlatesBaseModel";

export default function SlatesEditModel() {
    return new SlatesBaseModel();
}
